// @flow
import * as React from 'react';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { Point11 } from 'esm-web-pro/containers/pages/network/objects/point11/Point11';
import { ObjectContext } from 'esm-web-pro/containers/map/MapObject';
import { Accordion, Box, Heading } from 'grommet';
import { FormattedMessage } from 'react-intl';
import Point11PipesList from 'esm-web-pro/containers/pages/network/objects/point11/Point11PipesList';
import AccordionPanel from 'esm-web-pro/components/layout/sidePanel/AccordionPanel';
import PermitDocumentList from 'esm-web-pro/components/pages/network/PermitDocumentList';
import AssetList from 'esm-web-pro/components/pages/network/AssetList';
import Point11CableList from './Point11CableList';

type Props = {
    point: Point11,
    updateObject: Function,
    resource: Object,
    match: Object,
    map: Object,
    editor: BaseEditor,
    onView: Function,
    onRowClick: Function,
    clickedRow: ?string,
    loadedData: boolean,
}

const Point11Content = (props: Props) => {
    const {
        point, updateObject, resource, match, map, editor, onView, onRowClick, clickedRow, loadedData,
    } = props;
    const { permit_documents: permitDocuments, uuid, type: containerType } = point;
    const [activeIndices, setActiveIndices] = React.useState([1]);

    return (
        <ObjectContext.Consumer>
            {({ reload }) => (
                <Box height={{ min: '100%' }}>
                    <Accordion activeIndex={activeIndices} onActive={setActiveIndices}>
                        <AccordionPanel
                            label={(
                                <FormattedMessage
                                    id="pipe-content-title"
                                    defaultMessage="Pipes"
                                />
                            )}
                        >
                            <Point11PipesList
                                point={point}
                                reload={reload}
                                updateObject={updateObject}
                                resource={resource}
                                match={match}
                                map={map}
                                editor={editor}
                                onView={onView}
                                clickedRow={clickedRow}
                                onRowClick={onRowClick}
                                loadedData={loadedData}
                            />
                        </AccordionPanel>
                        <AccordionPanel label={(
                            <FormattedMessage
                                id="cable-plural"
                                defaultMessage="Cables"
                            />
                        )}
                        >
                            <Point11CableList
                                point={point}
                                reload={reload}
                                updateObject={updateObject}
                                resource={resource}
                                match={match}
                                map={map}
                                editor={editor}
                                onView={onView}
                                clickedRow={clickedRow}
                                onRowClick={onRowClick}
                                loadedData={loadedData}
                            />
                        </AccordionPanel>
                        <AccordionPanel label={(
                            <FormattedMessage
                                id="permit-documents"
                                defaultMessage="Permit Documents"
                            />
                        )}
                        >
                            <PermitDocumentList
                                documents={permitDocuments}
                                reload={reload}
                            />
                        </AccordionPanel>
                        {containerType === 'pop' && (
                            <AccordionPanel label={(
                                <FormattedMessage
                                    id="assets"
                                    defaultMessage="Assets"
                                />
                            )}
                            >
                                <AssetList container={point} map={map} />
                            </AccordionPanel>
                        )}
                    </Accordion>
                </Box>
            )}
        </ObjectContext.Consumer>
    );
};

export default Point11Content;
